import React from "react"
import { Box } from "@mui/material"
import { useSignal } from "@preact/signals-react"

import { AppDialog, AppDialogBody, AppDialogHeader, AppValueChip } from "@components"
import AppMoreCount from "@components/DataBlocks/MoreCount"

const MAX_VISIBLE = 3

export default function ReportsNameCell({ value }) {
	const open = useSignal(false)

	if (!Array.isArray(value) || value.length === 0) {
		return <Box sx={{ textAlign: 'center' }}>-</Box>
	}

	const visible = value.slice(0, MAX_VISIBLE)
	const hidden = value.length - MAX_VISIBLE

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
			{visible.map((item, idx) => <AppValueChip key={idx} tone="accent">{item}</AppValueChip>)}
			{hidden > 0 && <AppMoreCount count={hidden} onClick={e => { e.stopPropagation(); open.value = true }}/>}
			<AppDialog open={open.value} onClose={() => open.value = false} maxWidth="xs">
				<AppDialogHeader icon="file-lines" title="Reports" onClose={() => open.value = false}/>
				<AppDialogBody>
					<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
						{value.map((item, idx) => <AppValueChip key={idx} tone="accent">{item}</AppValueChip>)}
					</Box>
				</AppDialogBody>
			</AppDialog>
		</Box>
	)
}
